export default __webpack_public_path__ + "static/media/Head_2_Ear_1_C5.d092e2de.svg";